import { render, staticRenderFns } from "./IncomeExpenditure.vue?vue&type=template&id=c0b9efd8&scoped=true&"
import script from "./IncomeExpenditure.vue?vue&type=script&lang=js&"
export * from "./IncomeExpenditure.vue?vue&type=script&lang=js&"
import style0 from "./IncomeExpenditure.vue?vue&type=style&index=0&id=c0b9efd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b9efd8",
  null
  
)

export default component.exports